import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';
import type { AdminRole } from '@echo-work-platform/shared-types';
import { useAdminRoles } from '@/auth/admin-role-context';
import { homeRouteFor } from '@/auth/admin-role';
import { ForbiddenNotice } from '@/components/shared/forbidden-notice';

// Layout route guard: the server enforces the same rule, this only keeps the UI honest.
// Fails closed — pending shows a neutral placeholder, no overlap shows the forbidden notice.
export function RequireRole({ roles }: { roles: AdminRole[] }): JSX.Element {
  const { hasAnyRole, roles: mine, isPending } = useAdminRoles();
  if (isPending) {
    return <div className="card p-10 text-center text-sm text-muted-foreground">Betöltés…</div>;
  }
  return hasAnyRole(roles) ? <Outlet /> : <ForbiddenNotice homeTo={homeRouteFor(mine)} />;
}
